import { render } from "./CgvView.vue?vue&type=template&id=304e33c8&scoped=true"
import script from "./CgvView.vue?vue&type=script&lang=js"
export * from "./CgvView.vue?vue&type=script&lang=js"

import "./CgvView.vue?vue&type=style&index=0&id=304e33c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-304e33c8"]])

export default __exports__